import { apiClient } from './client';
import { API_CONFIG } from './config';

export type FileObject = {
  fileId: string;
  projectId: string;
  identifier: string;
  s3Url: string;
  type: string;
  createdAt: string;
  createdBy: string;
  localPath: string;
  updatedBy: string;
  updatedAt: string;
};

class FilesApi {
  private ep = API_CONFIG.endpoints.files;

  upload(fileName: string, fileBase64: string) {
    return apiClient.post<FileObject>(this.ep.upload, {
      file_name: fileName,
      file: fileBase64,
    });
  }

  getDetail(id: string) {
    return apiClient.get<FileObject>(this.ep.detail(id));
  }
}

export const filesApi = new FilesApi();
